<template>
	<v-dialog
		persistent
		max-width="600"
		v-model="dialog"
	>
		<v-card v-if="e">
			<v-card-title>
				<span>Skirti resursus</span>
			</v-card-title>
			<v-card-text>
				<v-form ref="form" class="mt-1">
					<table>
						<tr>
							<th>Vartotojas</th>
							<td>{{e["User"]}}</td>
						</tr>
					</table>
					<div class="mt-4">
						<template v-if="loading">
							<v-progress-circular
								indeterminate
								color="primary"
								:size="30"
								width="2"
							></v-progress-circular>
						</template>
						<template v-else-if="userParameters">
							<template v-if="userParameters == 'error'">
								<div>Atsiprašome, įvyko nenumatyta klaida: vartotojo parametrai nepasiekiami...</div>
							</template>
							<template v-else>
								<CommonSettingsFields
									:key="getKey('fields')"
									:values="userParameters"
									ref="numberFields"
								/>
							</template>
						</template>
					</div>
				</v-form>
			</v-card-text>
			<v-card-actions class="mx-4 pb-5">
				<v-btn
					color="blue darken-1"
					text
					v-on:click="save"
					outlined
					small
					:loading="saveInAction"
					:disabled="removalInAction || (userParameters == 'error')"
				>
					Išsaugoti
				</v-btn>
				<v-btn
					color="blue darken-1"
					text
					v-on:click="clear"
					outlined
					small
					:loading="removalInAction"
					:disabled="saveInAction"
					v-if="userHasParameters"
				>
					Trinti vartotojo resursus
				</v-btn>
				<v-btn
					color="blue darken-1"
					text
					v-on:click="closeDialog"
					outlined
					small
					:disabled="saveInAction || removalInAction"
				>
					Atšaukti
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import AdminHelper from "../helpers/AdminHelper";
	import CommonSettingsFields from "./CommonSettingsFields";

	export default {
		data: function(){
			var data = {
				dialog: false,
				saveInAction: false,
				removalInAction: false,
				e: null,
				loading: null,
				iteration: 0,
				userParameters: null,
				userHasParameters: null,
				maxInteractiveAtlases: null,
				rules: [v => !!v || "Laukas privalomas"]
			};
			return data;
		},
		created: function(){
			this.$vBus.$on("show-resources-dialog", this.showDialog);
		},
		beforeDestroy: function(){
			this.$vBus.$off("show-resources-dialog", this.showDialog);
		},
		components: {
			CommonSettingsFields
		},
		methods: {
			closeDialog: function(){
				this.e = null;
				this.dialog = false;
			},
			showDialog: function(e){
				this.iteration += 1;
				this.e = e;
				this.loading = true;
				this.dialog = true;
				this.userParameters = null;
				this.userHasParameters = false;
				AdminHelper.getUserParameters(e["User"]).then(function(userParameters){
					if (userParameters.length) {
						this.userParameters = userParameters[0]; // TODO! Ar visada bus tik vienas narys masyve??...
						this.userHasParameters = true;
						this.loading = false;
					} else {
						AdminHelper.getCommonSettings().then(function(data){
							this.userParameters = data.settings;
							this.loading = false;
						}.bind(this), function(){
							this.loading = false;
							this.userParameters = "error";
						}.bind(this));
					}
				}.bind(this), function(){
					this.loading = false;
					this.userParameters = "error";
				}.bind(this));
			},
			save: function(){
				var formValid = this.$refs.form.validate();
				if (formValid) {
					if (this.$refs.numberFields) {
						this.saveInAction = true;
						var params = {
							User: this.e["User"],
							MaxInteractiveAtlas: parseInt(this.$refs.numberFields.maxInteractiveAtlases),
							MaxPrintAtlas: parseInt(this.$refs.numberFields.maxPrintableAtlases),
							MaxMb: parseInt(this.$refs.numberFields.maxMb)
						};
						var create = true;
						if (this.userHasParameters) {
							create = false;
						}
						AdminHelper.updateUserParameters(params, create).then(function(){
							this.saveInAction = false;
							this.dialog = false;
						}.bind(this), function(){
							this.saveInAction = false;
							this.$vBus.$emit("show-message", "error");
						}.bind(this));
					}
				}
			},
			clear: function(){
				this.removalInAction = true;
				AdminHelper.deleteUserParameters(this.e["User"]).then(function(){
					this.removalInAction = false;
					this.dialog = false;
				}.bind(this), function(){
					this.removalInAction = false;
					this.$vBus.$emit("show-message", "error");
				}.bind(this));
			},
			getKey: function(key){
				key = key + "-" + this.iteration;
				return key;
			}
		}
	}
</script>

<style scoped>
	table {
		border-collapse: collapse;
	}
	td, th {
		border: 1px solid #cccccc;
		text-align: left;
		padding: 7px;
	}
	.v-select {
		width: 300px;
	}
</style>